import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Expertise from "../components/Expertise";
import Process from "../components/Process";
import WhyUs from "../components/WhyUs";
import Jobs from "../components/Jobs";
import FAQ from "../components/FAQ";
import ContactFooter from "../components/ContactFooter";

export default function Home({ onRecruit, onCandidater, onApply }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <Header onCandidater={onCandidater} />
      <main>
        <Hero onRecruit={onRecruit} onCandidater={onCandidater} />
        <Expertise onJobs={() => scrollTo("jobs")} />
        <Process />
        <WhyUs />
        <Jobs onApply={onApply} />
        <FAQ onContact={() => scrollTo("contact")} />
        <ContactFooter onRecruit={onRecruit} onCandidater={onCandidater} />
      </main>
    </>
  );
}
